export var CalculatorInputNames;
(function (CalculatorInputNames) {
    CalculatorInputNames["BASE_ASSET_INPUT"] = "baseAssetAmount";
    CalculatorInputNames["QOUTE_ASEET_INPUT"] = "quoteAssetAmount";
})(CalculatorInputNames || (CalculatorInputNames = {}));
//# sourceMappingURL=calculatorInputs.js.map